import { Link } from "react-router-dom";
import { BUSINESS, SUBURBS, SERVICES } from "@/lib/constants";

export default function Footer() {
  return (
    <footer className="bg-asphalt text-white/85 mt-24">
      <div className="rs-container py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="mb-4">
            <span className="inline-block bg-white p-2">
              <img src="/logo.png" alt="Site Cleanup" className="h-12 w-auto block" />
            </span>
          </div>
          <p className="text-sm max-w-md text-white/70">
            An Australian lead-generation platform that helps builders, developers and land owners get site clean-up quotes and matches enquiries with suitable local contractors — where available.
          </p>
          <div className="mt-6 text-sm space-y-1">
            <div><span className="text-white/50">Enquiries: </span><a className="text-white hover:text-safety" href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a></div>
          </div>
        </div>
        <div>
          <h4 className="font-display uppercase text-white text-sm tracking-widest mb-3">Services</h4>
          <ul className="space-y-2 text-sm">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.slug}><Link to="/services" className="hover:text-safety">{s.title}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-display uppercase text-white text-sm tracking-widest mb-3">Service Areas</h4>
          <ul className="space-y-2 text-sm">
            {SUBURBS.slice(0, 8).map((s) => (
              <li key={s.slug}><Link to={`/service-areas/${s.slug}`} className="hover:text-safety">{s.name}</Link></li>
            ))}
            <li><Link to="/service-areas" className="hover:text-safety underline underline-offset-4">All areas →</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="rs-container py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/60">
          <p>© {new Date().getFullYear()} Site Cleanup. Quote requests only — contractor referrals subject to availability and suitability.</p>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" className="hover:text-white">Terms & Disclaimer</Link>
            <Link to="/admin/login" className="hover:text-white" data-testid="footer-admin-link">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
